import { useMemo } from 'react';
import { useRouteMatch } from 'react-router';

import { doTabPathAndStringMatch } from '~/scenes/PortalViews/Views/EmployeeViews/Modules/components/EmployeeModuleTabs/data';

type PropsType<TabPath> = {
  defaultTab: TabPath;
  enabledTabPaths: TabPath[];
};

export const useSubTabPath = <TabPath>(props: PropsType<TabPath>) => {
  const { enabledTabPaths, defaultTab } = props;
  const { url } = useRouteMatch();
  const subMatch = useRouteMatch<{ tab?: string }>(`${url}/:tab`);

  const routeTab = useMemo(() => {
    const findTabByIdString = (tabId: string): TabPath | undefined => {
      return Object.values(enabledTabPaths).find((e) =>
        doTabPathAndStringMatch(e, tabId),
      );
    };

    const getTabByIdString = (tabId: string): TabPath => {
      const result = findTabByIdString(tabId);
      return !!result ? result : defaultTab;
    };

    return !!subMatch?.params?.tab
      ? getTabByIdString(subMatch.params.tab)
      : undefined;
  }, [enabledTabPaths, subMatch, defaultTab]);

  return { routeTab };
};
